// extracted by mini-css-extract-plugin
module.exports = {"container":"JWFooter-module__container__pfrY9","poweredBy":"JWFooter-module__poweredBy__1kRN8"};